import { dateTimeToDate } from 'src/common/date/dateTimeToDate';
import { TripRead } from 'src/common/external/bambi-api/bambiApi';

export function getTripDateFormValue(trip: TripRead) {
  const isClonedTrip = !trip.id && trip.scheduled_pickup_at;
  return isClonedTrip ? '' : dateTimeToDate(trip.scheduled_pickup_at);
}
